var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sk-chase",style:({'--color-dot':_vm.color})},[_c('div',{staticClass:"sk-chase-dot"}),_c('div',{staticClass:"sk-chase-dot"}),_c('div',{staticClass:"sk-chase-dot"}),_c('div',{staticClass:"sk-chase-dot"}),_c('div',{staticClass:"sk-chase-dot"}),_c('div',{staticClass:"sk-chase-dot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }